export default class CensusDataByNation {
  constructor(obj) {
    if (obj.by_nations) {
      this.nation = obj.by_nations.zip_code;
      this.median_rent = obj.by_nations.median_rent;
      this.median_household_income = obj.by_nations.median_household_income;
      this.mean_household_income = obj.by_nations.mean_household_income;
    }
  }
}
